export default "__VITE_ASSET__CWZW9emI__"